import { faHeart } from "@jewlr/pro-light-svg-icons/faHeart"
import { createSelector } from "@reduxjs/toolkit"
import { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { fetchCartShare } from "app-store-v2/share/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { IS_JEWLR, isTestMode } from "helpers/application"
import fetchWishlist from "hoc/fetch-wishlist"

import LineItem from "./line-item"

const selectWishlistProps = createSelector(
  [(state) => state.wishlist],
  (wishlist) => ({
    count: wishlist.count,
    items: wishlist.line_items,
    loading: !wishlist.show,
  })
)

const Main = () => {
  const dispatch = useDispatch()
  const { count, items, loading } = useSelector(selectWishlistProps)

  const openShareModal = useCallback(() => {
    dispatch(fetchCartShare("wishlist"))
    openModal("#share-modal")
  }, [dispatch, openModal])

  useEffect(() => {
    if (!isTestMode) {
      dataLayer.push({ event: "viewed-wishlist" })
    }
  }, [])

  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-26 tablet:text-34 font-bold">
          {IS_JEWLR() ? "My Wish List" : "Our Collection"}
        </h1>
        {IS_JEWLR() ? (
          loading ? (
            <Shimmer style={{ height: "22px", width: "100px" }} />
          ) : count > 0 ? (
            <Button onClick={openShareModal} text underline variant="secondary">
              Share Wish List
            </Button>
          ) : null
        ) : null}
      </div>
      <Divider className="bg-grey-20 tablet:mt-10 mb-24 mt-16" />
      {!loading && count == 0 ? (
        <>
          <p className="text-20 tablet:text-22 mb-24 font-bold">
            Your {IS_JEWLR() ? "Wish List" : "collection"} is currently empty.
          </p>
          <p className="text-20 tablet:text-22">
            Click the heart symbol [{" "}
            <FontAwesomeIcon className="text-black" icon={faHeart} /> ] beside
            any item you want to save and it will show here.
          </p>
        </>
      ) : (
        <div className="tablet:gap-24 tablet:grid-cols-3 desktop:grid-cols-4 grid grid-cols-2 gap-12">
          {loading
            ? [...Array(4)].map((_, index) => (
                <Shimmer
                  className="h-(--base-height) tablet:h-(--tablet-height) w-full"
                  key={index}
                  style={{
                    "--base-height": "228px",
                    "--tablet-height": "278px",
                  }}
                />
              ))
            : items.map((item) => <LineItem item={item} key={item.id} />)}
        </div>
      )}
    </>
  )
}

export default fetchWishlist(Main)
